import { ElMessage, ElLoading } from "element-plus";
import verConfig from './config';


export const setStorage = (name, value) => {
  return localStorage.setItem(name, value);
}

export const getStorage = (name) => {
  return localStorage.getItem(name);
}
export const removeStorage = (name) => {
  return localStorage.removeItem(name)
}

export const clearStorage = (name, flag = false) => {
  if (flag) {
    return localStorage.clear();
  }
  return removeStorage(name);
}


export const message = ({ content, duration = 2000, offset = 20 }, type = 'success') => {
  return ElMessage({
    type,
    message: content,
    duration,
    offset
  })
}

export const Toast = (content, type) => {
  return content && message({ content }, type);
}

let loadingInstance = null;

export const reqLoading = ({ target = document.body, text = '' } = {}) => {
  loadingInstance = ElLoading.service({
    target,
    lock: true,
    text,
    background: 'rgba(0,0,0,.7)'
  });
}

export const clearLoading = (callback = () => { }) => {
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
  callback();
}
export const time = (time) => {
  if (JSON.stringify(time).length == 10) {
    time *= 1000
  }
  let date = new Date(time);
  let year = date.getFullYear();
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');
  let hours = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  let seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

export const Img = (url = '', isCode = false) => {
  const commonUrl = verConfig.Base_Url + verConfig.Base_api + '/';
  if (isCode) return commonUrl + encodeURI(url);
  return commonUrl + url
}
export const codeImg = (url = '') => {
  const commonUrl = verConfig.Base_Url;
  return commonUrl + url
}

export const fixed = (num, digits = 2) => {
  if (!num) return (0).toFixed(digits);
  let digitsStr = '1';
  for (let i = 0; i < digits; i++) {
    digitsStr += '0'
  }
  const unit = Number(digitsStr);
  return (Math.round(num * unit) / unit).toFixed(digits);
}

export const useIncrease = (item) => {
  return fixed((item.price - item.dopen) / item.dopen * 100);
}

export const hasData = (data) => {
  if (typeof data === "object") {
    if (Array.isArray(data)) {
      return !!data.length;
    }
    return !!Object.keys(data).length;
  }
  return !!data;
}

export const useImg = (url, options = {}) => {
  const { Base_Url, Base_api } = options;
  if (url && url.charAt(0) === '/') {
    url = url.substring(1, url.length);
  }
  if (/^http/.test(url)) {
    return url;
  }
  return Base_api ? ((Base_Url || verConfig.Base_Url) + Base_api + url) : ((Base_Url || verConfig.Base_Url) + url);
}

export const strNullReg = (text = '') => {
  text = text.toString();
  let str = text.replace(/\s+/g, '');
  return str
}

export const timeoutChange = (callback = () => { }, time = 1000) => {
  let timer = setTimeout(() => {
    callback();
    clearTimeout(timer);
  }, time)
}

export const setClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    Toast("复制成功");
  } catch (err) {
    Toast("复制失败", 'error')
  }
} 